// animation
import { Fade } from "react-awesome-reveal";
// icons
import { PlusIcon, MinusIcon } from "utils/Icons";

const StepFive = ({
  formData,
  setFormData,
  setActiveStep,
  agesData,
  isLoading,
}) => {
  //   handle decrease child counts
  const handleDecreaseChildCount = (item) => {
    let id = item._id;
    let obj = formData?.children[id] || item;
    let newCount = obj?.count - 1 > 0 ? obj.count - 1 : 0;
    if (newCount > 0) {
      setFormData({
        ...formData,
        children: {
          ...formData.children,
          [id]: {
            ageRange: id,
            count: obj?.count - 1 > 0 ? obj.count - 1 : 0,
          },
        },
      });
    } else {
      let filtered = formData.children;
      delete filtered[id];
      setFormData({
        ...formData,
        children: filtered,
      });
    }
  };
  //   handle increase child counts
  const handleIncreaseChildCount = (item) => {
    let id = item._id;
    let obj = formData?.children[id] || item;
    setFormData({
      ...formData,
      children: {
        ...formData.children,
        [id]: {
          ageRange: id,
          count: obj.count ? obj.count + 1 : 1,
        },
      },
    });
  };

  //   toggle select
  const toggleOption = (item, count) => {
    let id = item._id;
      if (count) {
        if(formData.children[id]?.count){
          return
        }else{
          setFormData({
            ...formData,
            children: {
              ...formData.children,
              [id]: {
                ageRange: id,
                count: 1,
              },
            },
          });
        }
      } else {
        setFormData({
          ...formData,
          children: {
            ...formData.children,
            [id]: {
              ageRange: id,
            },
          },
        });
      }
  };

  return (
    <>
      <div className="step_card_body justify_content_start">
        <Fade triggerOnce delay={100} duration={1200}>
          <h3>
            We're going to customize <br /> MamaZen just for you
          </h3>
        </Fade>
        <br />
        <Fade triggerOnce delay={180} duration={1500}>
          <p>Please tap the ages of your kids</p>
        </Fade>
        <br />
        <br />
        <div>
          {isLoading ? (
            <p className="mx_auto w_100 text_center">
              <br /> <br />
              Loading...
              <br />
            </p>
          ) : agesData && agesData?.length > 0 ? (
            agesData?.map((item, index) => (
                item?.startAgeTitle ? (
                  <div
                  key={index}
                    role="button"
                    className={`frequency_box ages_box text_center cs_row 
                    ${
                      formData?.children[item?._id]?.ageRange === item?._id
                        ? " selected"
                        : ""
                    }
                    `}
                  >
                    {item?.startAgeTitle && (
                      <button
                        onClick={() => handleDecreaseChildCount(item)}
                        className="countBtn"
                      >
                        <MinusIcon />
                      </button>
                    )}
                    <p className="mx_auto">
                      {formData?.children[item._id]?.count}{" "}
                      {formData?.children[item._id]?.count > 1
                        ? item?.fullTitle_plural
                        : item?.fullTitle_single}
                    </p>
                    {item?.startAgeTitle && (
                      <button
                        onClick={() => handleIncreaseChildCount(item)}
                        className="countBtn"
                      >
                        <PlusIcon />
                      </button>
                    )}
                    <div
                      onClick={() => toggleOption(item, "count")}
                      role="button"
                      className="backdrop_ages_select"
                    ></div>
                  </div>
                ) : (
                  <div
                  key={index}
                    role="button"
                    className={`frequency_box ages_box text_center cs_row 
                    ${
                      formData?.children[item?._id]?.ageRange === item?._id
                        ? " selected"
                        : ""
                    }
                    `}
                    onClick={() => toggleOption(item)}
                  >
                    <p className="mx_auto">{item?.fullTitle_single}</p>
                  </div>
                )
            ))
          ) : (
            "Something went wrong! no data fetched."
          )}
        </div>
      </div>
      <br />
      <div className="mt_auto screen_sticky_footer">
        <Fade triggerOnce delay={220} duration={1300}>
          <button
            disabled={!Object.values(formData?.children)?.length > 0}
            onClick={() => setActiveStep(5)}
            className="cs_btn w_100"
          >
            Continue
          </button>
        </Fade>
      </div>
    </>
  );
};

export default StepFive;
